export default {
    'name': 'txt',
    'width': '45',
    'height': '41',
    'viewBox': '0 0 41 45',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M0 12.2015V42H37.3333V0H11.8018L0 12.2015Z\' fill=\'#DBEFFF\'/><rect width=\'26\' height=\'15\' transform=\'translate(14.6667 20)\' fill=\'#006CFD\'/><path d=\'M20.9155 32V26.03H18.5855V25H24.5255V26.03H22.1755V32H20.9155ZM26.2387 32H24.8987L27.2687 28.38L24.9287 25H26.3387L28.0887 27.58L29.7787 25H31.1387L28.7787 28.47L31.2087 32H29.8087L27.9787 29.3L26.2387 32ZM33.8112 32V26.03H31.4812V25H37.4212V26.03H35.0712V32H33.8112Z\' fill=\'white\'/>'
}
